export default __webpack_public_path__ + "static/media/ImageTwo.2d31a2b7.jpg";